import { FC } from 'react';

import { useUpdateOperationModal } from './context/UpdateOperationModalContext';
import UpdateOperationModalHeader from './components/UpdateOperationModalHeader';
import UpdateOperationModalBody from './components/UpdateOperationModalBody';
import UpdateOperationModalFooter from './components/UpdateOperationModalFooter';
import CustomLoading from '../../CustomLoading';

import '../Modals.scss';

const UpdateOperation: FC = () => {
  const { data } = useUpdateOperationModal();

  return (
    <>
      <UpdateOperationModalHeader />
      <UpdateOperationModalBody />
      <UpdateOperationModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default UpdateOperation;
